export default __webpack_public_path__ + "static/media/approch3.53e7eebb.jpg";